import { render, staticRenderFns } from "./InitialPage.vue?vue&type=template&id=200372b1&scoped=true"
import script from "./InitialPage.vue?vue&type=script&lang=js"
export * from "./InitialPage.vue?vue&type=script&lang=js"
import style0 from "./InitialPage.vue?vue&type=style&index=0&id=200372b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200372b1",
  null
  
)

export default component.exports